import { render } from "./terms-of-use.vue?vue&type=template&id=6e664284"
const script = {}

import exportComponent from "/Users/jason/u/acsi-ui-balancer-v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__